import * as angular from 'angular';
import { SdcFluxModule } from './../../../sdc/flux/sdc-flux.module';
import { newSdcGridComponent } from './../../../sdc/new-sdc-grid/new-sdc-grid.component';
import { AttendanceRouteConfig } from './attendance.route';
import { CreditGapsRouteConfig } from './credit-gaps.route';
import { DefaultSdcRouteConfig } from './default-sdc.route';
import { GradPlanningRouteConfig } from './grad-planning.route';
import { MarkingPeriodRouteConfig } from './marking-period.route';
import { NewSdcRouteConfig } from './new-sdc.route';
import { RegentsPlanningRouteConfig } from './regents-planning.route';
import { RegentsPrepRouteConfig } from './regents-prep.route';
import { SdcRootComponent } from './sdc-root.component';

export const NewSdcRoutesModule = angular
  .module('NewSdcRoutesModule', [SdcFluxModule])
  .config(NewSdcRouteConfig)
  .config(AttendanceRouteConfig)
  .config(DefaultSdcRouteConfig)
  .config(GradPlanningRouteConfig)
  .config(MarkingPeriodRouteConfig)
  .config(RegentsPrepRouteConfig)
  .config(RegentsPlanningRouteConfig)
  .config(CreditGapsRouteConfig)
  .component('newSdcGrid', newSdcGridComponent)
  .component('sdcRoot', SdcRootComponent).name;
